import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TokenProviderService } from '@api/authentication';
import { ApiConnectionsModel, ApiConnectionsRepository } from '@database/central';
import { IModal } from '@domain/business-layer';
import { ConnectionsManagerService, ConnectionTypeEnum } from '@domain/connections';
import { NavController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AppRoutingKeys } from '@shared';
import { Subscription } from 'rxjs';
import { AccountStateService } from '../../services/account-state.service';
import { AccountBaseComponent } from '../base';

@Component({
	selector: 'app-registration-connection',
	templateUrl: 'account-connection.component.html',
	styleUrls: ['../../account.scss']
})
export class AccountConnectionComponent extends AccountBaseComponent implements OnInit, OnDestroy {
	public formValidationMessages = [];
	public connectionId: string;
	public connectionsList: ApiConnectionsModel[] | null = null;
	public customDropdownOptions = {
		header: 'Select a connection',
		subHeader: 'Use connection manager to add connections',
		translucent: true
	};
	private subscriptions: Subscription[] = [];

	public constructor(
		private accountStateService: AccountStateService,
		private translate: TranslateService,
		private tokenProviderService: TokenProviderService,
		private apiConnectionsRepository: ApiConnectionsRepository,
		private connectionsManagerService: ConnectionsManagerService,
		public navController: NavController,
		public router: Router
	) {
		super(navController, router);
	}

	public get helperText(): string {
		const content = this.isRegistration() ? 'registration.content.connection' : 'reset.content.connection';
		return this.translate.instant(content);
	}

	public ngOnInit(): void {
		this.subscriptions.push(
			this.apiConnectionsRepository
				.getConnections$()
				.subscribe((connections: ApiConnectionsModel[] | null) => (this.connectionsList = connections))
		);

		this.fieldFormControl = new FormControl('', [Validators.required]);

		this.registrationForm = new FormGroup({
			fieldFormControl: this.fieldFormControl
		});

		this.formValidationMessages = [
			{
				type: 'required',
				message: this.translate.instant('registration.form.validations.connection.required')
			}
		];

		// If going in the reset/registration flow, you should have no token still left in the local storage.
		// this.tokenProviderService.save('');
	}

	public async onSubmit(formValues: { fieldFormControl: string }): Promise<void> {
		if (!this.isFormValid()) {
			return;
		}

		console.log(formValues.fieldFormControl);
		

		this.accountStateService.setConnection(formValues.fieldFormControl);
		const route = this.isRegistration() ? 'registration' : 'reset';

		await this.navController.navigateForward(`${route}/${AppRoutingKeys.urlPathRegistrationUsername}`);
	}

	public goToConnectionManager(): void {
		this.subscriptions.push(
			this.connectionsManagerService.open(ConnectionTypeEnum.noOptions).subscribe(async (modal: IModal) => {
				if (modal.data) {
					this.connectionId = modal.data;
					this.registrationForm.setValue({ fieldFormControl: modal.data });
				}
			})
		);
	}

	public ngOnDestroy(): void {
		this.subscriptions.forEach((subscription) => {
			subscription.unsubscribe();
		});
	}
}
